<template>
  <div class="share__container">
    <span class="share__title text-base">Compartilhe</span>

    
    <div class="share__list justify-center">
      <button-favorite :content-id="contentId" />

      <button-like :content-id="contentId" />

      <a :href="shareURLFor('facebook')" target="_blank" rel="noopener" class="share__icon" v-tooltip="'Compatilhar no Facebook'">
        <i class="fab fa-facebook"></i>
        <span class="hidden">Compatilhar no Facebook</span>
      </a>

      <a :href="shareURLFor('twitter')" target="_blank" rel="noopener" class="share__icon" v-tooltip="'Compatilhar no Twitter'">
        <i class="fab fa-twitter"></i>
        <span class="hidden">Compatilhar no Twitter</span>
      </a>

      <a :href="shareURLFor('linkedin')" target="_blank" rel="noopener" class="share__icon" v-tooltip="'Compatilhar no LinkedIn'">
        <i class="fab fa-linkedin"></i>
        <span class="hidden">Compatilhar no LinkedIn</span>
      </a>

      <button-link />
    </div>
  </div>
</template>

<script>
import { shareURLFor } from './share'
import ButtonLike from '../contents/ButtonLike'
import ButtonFavorite from '../contents/ButtonFavorite'
import ButtonLink from './ButtonLink'

export default {
  components: {
    ButtonLink,
    ButtonLike,
    ButtonFavorite,
  },

  props: {
    contentId: {
      type: String,
      default: ''
    }
  },

  methods: {
    shareURLFor
  }
}
</script>
